<template>
  <div>
    <Header />
    <main>
      <Hero />
      <HowItWorks />
      <Testimonials />
      <Faq />
      <CtaSection />
    </main>
    <Footer />
  </div>
</template>

<script lang="ts" setup>
import CtaSection from "./CtaSection.vue";
import Faq from "./Faq.vue";
import Footer from "./Footer.vue";
import Header from "./Header.vue";
import Hero from "./Hero.vue";
import HowItWorks from "./HowItWorks.vue";
import Testimonials from "./Testimonials.vue";
</script>
